import { useState, useMemo } from "react";
import Fuse from "fuse.js";

interface IUseSearchProps {
  dataSet: any[];
  keys: any[];
  threshold?: number;
}

export default function useSearch({
  dataSet,
  keys,
  threshold = 0.5,
}: IUseSearchProps) {
  const [searchValue, setSearchValue] = useState("");

  const fuse = useMemo(() => {
    const options = {
      includeScore: true,
      keys,
      shouldSort: true,
      useExtendedSearch: true,
      isCaseSensitive: false,
      ignoreLocation: false,
      includeMatches: true,
      threshold: 0.3,
      location: 0,
      distance: 100,
      maxPatternLength: 30,
      minMatchCharLength: 1,
    };
    return new Fuse(dataSet, options);
  }, [dataSet, keys]);

  const results = useMemo(() => {
    if (!searchValue) return dataSet;
    const searchResults = fuse.search(searchValue);
    let response = searchResults
      ?.map((fuseResult) => fuseResult?.item);
    return response;
  }, [fuse, searchValue, dataSet]);

  return {
    searchValue,
    setSearchValue,
    results,
  };
}
